module.exports = __webpack_public_path__ + "static/img/brees-2003-1.0effe08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2003-1.jpg
// module id = f4Fx
// module chunks = 1